import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'fieldset'];

  connect() {
    this.toggle();
  }

  toggle() {
    const inputs = Array.from(this.fieldsetTarget.querySelectorAll('input'));

    if (this.checkboxTarget.checked) {
      this.fieldsetTarget.classList.remove('opacity-0', 'pointer-events-none');
      this.fieldsetTarget.setAttribute('aria-hidden', 'false');

      inputs.forEach(input => input.disabled = false);
    } else {
      this.fieldsetTarget.classList.add('opacity-0', 'pointer-events-auto');
      this.fieldsetTarget.setAttribute('aria-hidden', 'true');

      inputs.forEach(input => input.disabled = true);
    }
  }
}
